import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  SupplierBillListReq,
  SupplierBillListRes,
  ActionSupplierBillRes,
  CreateSupplierBillReq,
  SupplierBillDetailReq,
  SupplierBillDetailRes,
  DeleteSupplierBillReq,
} from './types'

export const getSupplierBillListAction = createAsyncAction(
  'SUPPLIER_BILL/GET_SUPPLIER_BILL_LIST_REQ',
  'SUPPLIER_BILL/GET_SUPPLIER_BILL_LIST_SUCCESS',
  'SUPPLIER_BILL/GET_SUPPLIER_BILL_LIST_FAILURE',
)<SupplierBillListReq, SupplierBillListRes, Error>()

export const getSupplierBillDetailAction = createAsyncAction(
  'SUPPLIER_BILL/GET_SUPPLIER_BILL_DETAIL_REQ',
  'SUPPLIER_BILL/GET_SUPPLIER_BILL_DETAIL_SUCCESS',
  'SUPPLIER_BILL/GET_SUPPLIER_BILL_DETAIL_FAILURE',
)<SupplierBillDetailReq, SupplierBillDetailRes, Error>()

export const createSupplierBillAction = createAsyncAction(
  'SUPPLIER_BILL/UPDATE_SUPPLIER_BILL_REQ',
  'SUPPLIER_BILL/UPDATE_SUPPLIER_BILL_SUCCESS',
  'SUPPLIER_BILL/UPDATE_SUPPLIER_BILL_FAILURE',
)<CreateSupplierBillReq, ActionSupplierBillRes, Error>()

export const deleteSupplierBillAction = createAsyncAction(
  'SUPPLIER_BILL/DELETE_SUPPLIER_BILL_REQ',
  'SUPPLIER_BILL/DELETE_SUPPLIER_BILL_SUCCESS',
  'SUPPLIER_BILL/DELETE_SUPPLIER_BILL_FAILURE',
)<DeleteSupplierBillReq, ActionSupplierBillRes, Error>()

export const clearEventAction = createStandardAction('SUPPLIER_BILL/CLEAR_EVENT')<void>()
